import React, { Component } from "react";
import Button from "../framework/Button/Button";
import List from "./List";
import "./segment-detail.css";
import moment from "moment";
import {
  getMapVectorOptions,
  splitNumber,
  pdfReportHeaderDataUri,
  addPdfFooter,
} from "../../utils/utility";
import FlatButton from "material-ui/FlatButton";

import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import {
  map,
  find,
  reduce,
  isEmpty,
  uniqBy,
  isNil,
  remove,
  forEach,
  groupBy,
  filter,
} from "lodash";
import {
  withGoogleMap,
  GoogleMap,
  Circle,
  Polygon,
  Rectangle,
} from "react-google-maps";
import { Row, Col, FullRow } from "../framework/Grid";
import CreateCampaign from "../Segment/List/CreateCampaign";
import ActivateAudienceDialog from "./ActivateAudienceDialog";
import Checkbox from "material-ui/Checkbox";
import Dialog from "material-ui/Dialog";
import { apiBaseUrl } from "../../env";
import isEqual from "lodash/isEqual";

const pdfConverter = require("jspdf");
const html2canvas = require("html2canvas");
const google = window.google;
const PAGE_WIDTH = 186;

class SegmentDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemKey: [
        "Archive Date",
        "Creation Date",
        "Client",
        "Business Unit",
        "Attributes Selected",
        "Audience",
        "Reach by channel",
      ],
      list: [],
      showDataLoadingDialog: false,
      loadingText: "Segment data loading...",
      ifCreateAudienceFile: false, // pop out the create audience file
      openCreateCampaignDialog: false,
      openArchiveDialog: false,
      ifShowEmailSubCheckbox: false, // when email checkbox is selected change the value to `true`
      ifReturnEmailChecked: false, // when `return file as hashed emails` checkbox is selected set value to `true`
      ifSocialMediaChecked: false, // when `Social Media` checkbox is selected set value to `true`
      socialMediaFacebook: false, // when `the social media's selection facebook` checkbox is selected set value to `true`
      socialMediaGoogle: false, // when `the social media's selection google` checkbox is selected set value to `true`
      ifDisplayChecked: false, // when `Display Advertising` checkbox is selected set value to `true`
      createCampaign_segment_id: "",
      createCampaign_clientId: "", // the client id for create campaign component
      gmapIsReady: false,
      disabledDlBtn: false,
      showDownloadDialog: false,
      showActivateDialog: false,
    };
  }
  componentWillMount() {
    this.props.clearSegmentSummary();
  }
  componentDidMount() {
    this.props.fetchSegmentSummary(this.props.match.params.id);
    if (parseInt(this.props.selected_client > 0)) {
      this.props.loadAttributes(this.props.selected_client);
    }
  }
  componentWillUnmount() {
    this.props.clearSegmentSummary();
  }
  componentWillReceiveProps(nextProps) {
    let itemobj = [];
    let list = []; // for final array

    if (nextProps.selected_client !== this.props.selected_client) {
      this.props.loadAttributes(nextProps.selected_client);
    }
    if (nextProps.segment_summary) {
      if (this.props.segment_summary) {
        if (this.props.segment_summary.id !== nextProps.segment_summary.id)
          this.props.selectClient(nextProps.segment_summary.clientId);
      } else {
        this.props.selectClient(nextProps.segment_summary.clientId);
        const rules = [];
        map(nextProps.segment_summary.rules, rule => {
          rules.push({
            attributeId: rule.attributeId,
            values: rule.values,
          });
        });
        this.props.getSegmentRulesCounts(
          {
            rules: rules,
            filtered: {
              targetHouseholdsOnly: Boolean(
                nextProps.segment_summary.targetHouseholdsOnly,
              ),
            },
          },
          nextProps.segment_summary.id,
        );
        this.props.getSegmentTotalCounts(
          {
            rules: rules,
            filtered: {
              targetHouseholdsOnly: Boolean(
                nextProps.segment_summary.targetHouseholdsOnly,
              ),
            },
          },
          nextProps.segment_summary.id,
        );
      }
      this.setState({
        createCampaign_segment_id: nextProps.segment_summary.id,
        createCampaign_clientId: nextProps.segment_summary.clientId,
      });
    }
    if (!isEmpty(nextProps.active_segment_attributes)) {
      let rawData = JSON.parse(nextProps.active_segment_attributes.rawData);
      nextProps.segment_active_creation.selected_segments =
        rawData.selected_segments;
      nextProps.segment_active_creation.plotted_values = rawData.plotted_values;
      nextProps.segment_active_creation.selected_city = rawData.selected_city;
      nextProps.segment_active_creation.selected_state = rawData.selected_state;
      nextProps.segment_active_creation.selected_county =
        rawData.selected_county;
      nextProps.segment_active_creation.selected_dma = rawData.selected_dma;
      nextProps.segment_active_creation.zipcode = rawData.zipcode;
      nextProps.segment_active_creation.segment_name = rawData.name;
      nextProps.active_segment_attributes.rules.forEach(item => {
        nextProps.segment_active_creation.rules_id.push({
          id: item.id,
          attributeId: item.attributeId,
        });
      });
      nextProps.segment_active_creation.segment_id =
        nextProps.active_segment_attributes.id;
    }
    if (
      (nextProps.segment_summary &&
        nextProps.value_typehead &&
        nextProps.rules_count &&
        (!this.props.segment_summary ||
          !this.props.value_typehead ||
          !this.props.rules_count)) ||
      !isEqual(nextProps.categories, this.props.categories)
    ) {
      nextProps.value_typehead.forEach(item => {
        const obj = nextProps.segment_summary
          ? JSON.parse(nextProps.segment_summary.rawData)
          : null;
        if (obj && obj.selected_segments) {
          let queryArr = obj.selected_segments;
          queryArr.forEach(id => {
            if (item.id === id) {
              itemobj.push(item);
            }
          });
        }
      });
      if (nextProps.categories) {
        nextProps.categories.forEach(item => {
          item.attributes.forEach(attr => {
            if (attr.values) {
              const obj = JSON.parse(nextProps.segment_summary.rawData);
              if (obj && obj.selected_segments) {
                attr.values.forEach(value => {
                  obj.selected_segments.forEach(id => {
                    let attributes = [];
                    let attributes_values = [];
                    if (parseInt(value.id, 10) === parseInt(id, 10)) {
                      attributes_values.push(value);
                      attributes.push({
                        id: attr.id,
                        name: attr.name,
                        awId: attr.awId,
                        values: attributes_values,
                      });
                      const segmentAttr = find(list, m => {
                        return parseInt(m.id, 10) === parseInt(item.id, 10);
                      });
                      if (segmentAttr === undefined) {
                        list.push({
                          id: item.id,
                          name: item.name,
                          attributes,
                        });
                      } else {
                        const _attr = find(segmentAttr.attributes, sattr => {
                          return sattr.id === attr.id;
                        });
                        if (_attr === undefined)
                          segmentAttr.attributes = segmentAttr.attributes.concat(
                            attributes,
                          );
                        else
                          _attr.values = _attr.values.concat(
                            attributes[0].values,
                          );
                      }
                    }
                  });
                });
              }
            }
            if (attr.subAttributes) {
              let subAttributes = [];
              let subAttributes_values = [];
              attr.subAttributes.forEach(attr1 => {
                attr1.values.forEach(value => {
                  const obj = JSON.parse(nextProps.segment_summary.rawData);
                  if (obj && obj.selected_segments) {
                    obj.selected_segments.forEach(id => {
                      if (value.id === id) {
                        subAttributes_values.push({
                          label: attr1.name + " - " + value.label,
                          total: value.total,
                          id: value.id,
                        });
                        subAttributes.push({
                          id: attr1.id,
                          name: attr.name,
                          parentId: attr1.parentId,
                          values: subAttributes_values,
                        });
                      }
                    });
                  }
                });
              });
              if (!isEmpty(subAttributes)) {
                list.push({
                  id: item.id,
                  name: item.name,
                  attributes: uniqBy(
                    uniqBy(subAttributes, att => {
                      return att.id;
                    }),
                    attr => {
                      return attr.parentId;
                    },
                  ),
                });
              }
            }
          });
        });
        map(list, l => {
          map(l.attributes, attr => {
            let total = 0;
            map(attr.values, v => {
              let vid = v.id.toString().substring(0, 3);
              if (vid === "140" || vid === "150") {
                vid = v.id.toString().substring(0, 4);
              }
              const vCount = this.getAttributeCount(
                parseInt(vid, 10),
                v.label,
                nextProps,
              );
              v.total = vCount;
              total += vCount;
            });
            attr["total"] = total;
          });
        });
        //Auto make and model
        map(list, l => {
          if (l.id === 7) {
            map(l.attributes, attr => {
              if (attr.id === 605 || attr.id === 606) {
                const _l = find(list, l => {
                  return l.id === "605606";
                });
                if (_l) {
                  _l.attributes.push(Object.assign({}, attr));
                } else {
                  list.push(
                    Object.assign(
                      {},
                      {
                        id: "605606",
                        name: attr.name,
                        attributes: [Object.assign({}, attr)],
                      },
                    ),
                  );
                }
              }
            });
            remove(l.attributes, attr => {
              return attr.id === 605 || attr.id === 606;
            });
          }
        });
        remove(list, l => {
          return l.id === 7 && isEmpty(l.attributes);
        });
        //dedup
        const resultList = [];
        forEach(
          groupBy(list, l => {
            return l.id;
          }),
          (val, key) => {
            let attrs = [];
            map(val, v => {
              attrs = attrs.concat(v.attributes);
            });
            resultList.push({
              id: parseInt(key, 10),
              name: val[0].name,
              attributes: attrs,
            });
          },
        );
        this.setState({
          list: resultList,
        });
      }
      this.setState({ showDataLoadingDialog: false });
    } else {
      if (!this.props.segment_summary || !this.props.rules_count) {
        this.setState({
          showDataLoadingDialog: true,
          loadingText: "Segment data loading...",
        });
      }
    }
  }
  noRepeatArr(arr) {
    return [...new Set(arr)];
  }
  handleListClick(e) {
    let parentNode = null;
    if (e.target.nodeName === "SPAN" || e.target.nodeName === "STRONG") {
      parentNode = e.target.parentNode.parentNode;
    } else if (e.target.nodeName === "SECTION") {
      parentNode = e.target.parentNode;
    } else {
      return;
    }
    if (parentNode.classList) {
      parentNode.classList.toggle("active");
    }
  }

  handleMapMounted(map) {
    this._map = map;
    if (this._map && this._vector) {
      try {
        this._map.fitBounds(this._vector.getBounds());
      } catch (ex) {}
    }
  }

  generateGeoContent() {
    let result = "";
    const { segment_summary } = this.props;
    if (segment_summary) {
      const rawData = JSON.parse(segment_summary.rawData);
      if (rawData.plotted_values) {
        const { addressLabel, radius, driveTime } = rawData.plotted_values;

        if (radius && addressLabel) {
          result = radius + " MILE(S) FROM " + addressLabel;
        }
        if (driveTime && addressLabel) {
          result = driveTime + " HOUR(S) DRIVE FROM " + addressLabel;
        }
        result = result
          .replace(",USA", "")
          .replace(", USA", "")
          .replace("USA", "");
      }
    }
    return result;
  }

  handleGoogleIdle() {
    if (!this.state.gmapIsReady) {
      this.setState({
        gmapIsReady: true,
      });
    }
  }

  generateMapContent() {
    let PlottedRadiusMap = null;
    const { segment_summary } = this.props;
    if (!segment_summary) return;
    const raw = JSON.parse(segment_summary.rawData);
    const doms = [];
    if (!isEmpty(raw.plotted_values)) {
      const { addressLabel } = raw.plotted_values;
      if (addressLabel) {
        // geoText = driveTime ? 'GEOGRAPHIC : Drive ' + driveTime + ' Hour(s) From ' + addressLabel.replace(", United States", "") :
        //   'GEOGRAPHIC : ' + radius + ' Mile(s) From ' + addressLabel.replace(", United States", "")
      } else {
        // geoText = "GEOGRAPHIC : AREA SELECTED"
        let vector = null;
        const plottedRadius = raw.plotted_values;
        switch (plottedRadius.type) {
          case "circle":
            vector = (
              <Circle
                ref={elm => (this._vector = elm)}
                center={plottedRadius.center}
                radius={plottedRadius.radius}
                options={getMapVectorOptions()}
              />
            );
            break;
          case "polygon":
            vector = (
              <Polygon
                ref={elm => (this._vector = elm)}
                path={
                  typeof plottedRadius.path === "string"
                    ? google.maps.geometry.encoding.decodePath(
                        plottedRadius.path,
                      )
                    : plottedRadius.path
                }
                options={getMapVectorOptions()}
              />
            );
            break;
          case "rectangle":
          default:
            vector = (
              <Rectangle
                ref={elm => (this._vector = elm)}
                bounds={plottedRadius.bounds}
                radius={plottedRadius.radius}
                options={getMapVectorOptions()}
              />
            );
            break;
        }
        if (vector) {
          PlottedRadiusMap = withGoogleMap(props => (
            <GoogleMap
              zoom={plottedRadius.zoom}
              center={plottedRadius.center}
              onIdle={this.handleGoogleIdle.bind(this)}
              defaultOptions={{
                streetViewControl: false,
                mapTypeControl: false,
                zoomControl: false,
                scrollwheel: false,
                draggable: false,
              }}
              ref={this.handleMapMounted.bind(this)}
            >
              {vector}
            </GoogleMap>
          ));
        }
      }

      const row = (
        <div key="geo-text-container" style={{ width: "100%" }}>
          <Row
            className="no-padding geo-map-row-container"
            style={{ padding: 0 }}
          >
            <Col
              xs="12"
              sm="12"
              md="12"
              lg="12"
              className={PlottedRadiusMap && "google_map_container no-padding"}
              style={{ height: "228px" }}
            >
              {PlottedRadiusMap ? (
                <PlottedRadiusMap
                  containerElement={<div style={{ height: `100%` }} />}
                  mapElement={<div style={{ height: `100%` }} />}
                />
              ) : null}
            </Col>
          </Row>
        </div>
      );
      doms.unshift(row);
    }

    return (
      <div
        key="map-view-container"
        style={{
          maxHeight: this.props && this.props.width > 1400 ? "480px" : "300px",
          overflowX: "hidden",
          overflowY: "auto",
          width: "80%",
          height: "230px",
          lineHeight: "unset",
          paddingLeft: "0px",
          marginLeft: "-50px",
          marginTop: "10px",
        }}
      >
        {doms}
      </div>
    );
  }
  generateAutoContent(item) {
    const COLORS = [
      "#050505",
      "#1A4457",
      "#3487AD",
      "#5D9FBE",
      "#85B7CE",
      "#D6E7EF",
    ];
    const attrCount = reduce(
      item.attributes,
      function(sum, attr) {
        return (sum += attr.values.length);
      },
      0,
    );
    let result = item.attributes[0].values;
    if (item.attributes.length < 1) return;
    if (item.attributes.length > 1) {
      result = item.attributes[0].values.concat(item.attributes[1].values);
    } else {
      result = item.attributes[0].values;
    }
    map(result, o => {
      let attrId = o.id.toString().startsWith("605") ? 605 : 606;
      o.total = this.getAttributeCount(attrId, o.label);
    });
    return (
      <div className="demographic base" key={item.id}>
        <h3>AUTO MAKE/MODEL ({attrCount})</h3>
        <ul>
          {result.map((item, index) => (
            <li
              className="auto-make-list"
              key={"li-" + item.id}
              style={{ marginTop: "-1px" }}
            >
              <div
                key={"div-" + item.id}
                style={{ height: "53px", marginBottom: "1px" }}
              >
                <p className="clearfix" ref="pElement">
                  <span
                    className="color-indicator"
                    style={{ background: COLORS[index % COLORS.length] }}
                  >
                    &nbsp;
                  </span>
                  <span className="pull-left">{item.label}</span>
                  <strong className="pull-right">
                    {splitNumber(item.total)()}
                  </strong>
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }
  getAttributeCount(attrId, attrVal, props) {
    //attrId: 1: state, 3: city, 605: auto make, 606: automodel
    const { rules_count } = props ? props : this.props;
    const obj = find(rules_count, el => {
      return el.attributeId === attrId;
    });
    if (obj && obj.counts) {
      if (attrId === 90 || attrId === 91)
        //drive time/plotted radius
        return obj.counts[0].value;
      const countObj = find(obj.counts, o => {
        return (
          o.key === attrVal || obj.attributeName + " - " + o.key === attrVal
        );
      });
      if (countObj) return countObj.value;
    }
    return 0;
  }
  generateGeoAttributesContent() {
    //return this.generateGeoContent()
    const { segment_summary } = this.props;
    if (segment_summary) {
      const rawData = JSON.parse(this.props.segment_summary.rawData);
      const {
        plotted_values,
        selected_city,
        selected_state,
        selected_county,
        selected_dma,
        zipcode,
      } = rawData;
      if (
        isEmpty(plotted_values) &&
        isEmpty(selected_city) &&
        isEmpty(selected_state) &&
        isEmpty(selected_county) &&
        isEmpty(selected_dma) &&
        isEmpty(zipcode)
      )
        return null;
      if (isEmpty(rawData.plotted_values)) {
        const cityItems = selected_city.map(v => {
          return (
            <div key={v.id} style={{ height: "53px", marginBottom: "1px" }}>
              <p className="clearfix pl-10" ref="pElement">
                <span className="pull-left" style={{ fontWeight: "bold" }}>
                  {v.state + " - " + v.label}
                </span>
              </p>
            </div>
          );
        });

        const stateItems = selected_state.map(v => {
          return (
            <div key={v.id} style={{ height: "53px", marginBottom: "1px" }}>
              <p className="clearfix pl-10" ref="pElement">
                <span className="pull-left" style={{ fontWeight: "bold" }}>
                  {v.label}
                </span>
              </p>
            </div>
          );
        });
        const countyItems = selected_county.map(v => {
          return (
            <div key={v.id} style={{ height: "53px", marginBottom: "1px" }}>
              <p className="clearfix pl-10" ref="pElement">
                <span className="pull-left" style={{ fontWeight: "bold" }}>
                  {v.label}
                </span>
              </p>
            </div>
          );
        });
        const dmaItems = selected_dma.map(v => {
          return (
            <div key={v.id} style={{ height: "53px", marginBottom: "1px" }}>
              <p className="clearfix pl-10" ref="pElement">
                <span className="pull-left" style={{ fontWeight: "bold" }}>
                  {v.value + " - " + v.label}
                </span>
              </p>
            </div>
          );
        });

        const zipItems = zipcode.map(v => {
          return (
            <div
              key={v.zipcode}
              style={{ height: "53px", marginBottom: "1px" }}
            >
              <p className="clearfix pl-10" ref="pElement">
                <span className="pull-left" style={{ fontWeight: "bold" }}>
                  {v.zipcode}
                </span>
              </p>
            </div>
          );
        });
        return (
          <div className="demographic base " key="geo-city-state-container">
            <h3>Geography</h3>
            <ul>
              <li
                className="active"
                key={"cities-li"}
                style={{
                  marginTop: "-1px",
                  display: isEmpty(selected_city) ? "none" : "block",
                }}
              >
                <section className="clearfix">
                  <span className="pull-left">CITIES ({cityItems.length})</span>
                </section>

                {cityItems}
                <div className="arrow-down" />
              </li>
              <li
                className="active"
                key={"states-li"}
                style={{
                  marginTop: "-1px",
                  display: isEmpty(selected_state) ? "none" : "block",
                }}
              >
                <section className="clearfix">
                  <span className="pull-left">
                    STATES  ({stateItems.length})
                  </span>
                </section>
                {stateItems}
                <div className="arrow-down" />
              </li>
              <li
                className="active"
                key={"counties-li"}
                style={{
                  marginTop: "-1px",
                  display: isEmpty(selected_county) ? "none" : "block",
                }}
              >
                <section className="clearfix">
                  <span className="pull-left">
                    COUNTIES ({countyItems.length})
                  </span>
                </section>
                {countyItems}
                <div className="arrow-down" />
              </li>
              <li
                className="active"
                key={"dmas-li"}
                style={{
                  marginTop: "-1px",
                  display: isEmpty(selected_dma) ? "none" : "block",
                }}
              >
                <section className="clearfix">
                  <span className="pull-left">DMA ({dmaItems.length})</span>
                </section>

                {dmaItems}
                <div className="arrow-down" />
              </li>
              <li
                className="active"
                key={"zipcode-li"}
                style={{
                  marginTop: "-1px",
                  display: isEmpty(zipcode) ? "none" : "block",
                }}
              >
                <section className="clearfix">
                  <span className="pull-left">ZIPCODES  ({zipcode.length})</span>
                </section>

                {zipItems}
                <div className="arrow-down" />
              </li>
            </ul>
          </div>
        );
      } else {
        const { addressLabel } = rawData.plotted_values;
        if (!isNil(addressLabel)) {
          return (
            <div
              className="demographic geography base"
              key="geo-address-container"
            >
              <h3>Geography</h3>
              <ul>
                <List itemName="Location">{this.generateGeoContent()}</List>
              </ul>
            </div>
          );
        } else {
          return (
            <div
              className=" demographic base google-map no-padding-bottom"
              key="geo-plotted-radius-container"
            >
              <h3>Geography</h3>
              <li
                className="active"
                key={"plotted-values-map"}
                style={{ marginTop: "-1px" }}
              >
                <section className="clearfix no-border-bottom">
                  <span className="pull-left">Plotted Radius</span>
                </section>
                <div style={{ height: "250px", width: "100%" }}>
                  {this.generateMapContent()}
                </div>
                <div className="arrow-down" />
              </li>
            </div>
          );
        }
      }
    }
  }

  _addPdfElements(
    attrsCanvas,
    pdf,
    top,
    pageWidth,
    fileName,
    ratio,
    client_name,
    bu_name,
    height,
    callback,
  ) {
    map(attrsCanvas, canva => {
      /*
      const canvaHeight = canva.height / ratio + top + 3;
      if (canvaHeight >= 280) {
        addPdfFooter(pdf);
        pdf.addPage("a4", "p");
        this._addPdfHeader(pdf, client_name, bu_name);
        top = 30;
        setTimeout(function() {
          pdf.addImage(canva.toDataURL(), "PNG", 12, top, pageWidth, 0);
          top += (canva.height * PAGE_WIDTH) / canva.width + 4;
        }, 200);
      } else {*/
      pdf.addImage(canva.toDataURL(), "PNG", 12, top, pageWidth, 0);
      top += (canva.height * PAGE_WIDTH) / canva.width + 4;
      //}
    });

    if (height > 296) {
      addPdfFooter(pdf, height - 15);
    } else {
      addPdfFooter(pdf);
    }
    setTimeout(
      function() {
        pdf.save(fileName);
        this.setState({ showDataLoadingDialog: false });
        callback && callback();
      }.bind(this),
      5000,
    );
  }
  _addPdfHeader(pdf, client_name, bu_name) {
    pdf.setFillColor(127, 127, 127);
    pdf.rect(0, 15, 210, 10, "F");

    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(9);
    pdf.setFontType("bold");
    pdf.addImage(pdfReportHeaderDataUri(), "PNG", 10.5, 3, 60, 0);
    pdf.text(198, 8, moment().format("MMMM DD, YYYY"), null, null, "right");

    pdf.setTextColor(255, 255, 255);
    pdf.setFontType("bold");
    pdf.text(12, 21, "Client:");
    //const lenClientName = getTextSize(client_name.trim(), 'helvetica')
    pdf.setFontType("normal");
    pdf.text(26, 21, client_name ? client_name.trim() : "");
    //cm to inches
    let start = 90; //46 + lenClientName.width * 0.3937 + 0.4
    if (!isEmpty(bu_name)) {
      pdf.setFontType("bold");
      pdf.text(start, 21, "Business Unit:");
      start += 26.5;
      pdf.setFontType("normal");
      pdf.text(start, 21, bu_name ? bu_name.trim() : "");
    }
    pdf.setFillColor(255);
    start = 12;
    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(10);
    //pdf.text(12, 30, 'Campaigns  >  ' + campaignDetail.name );
  }

  _downloadAsPDF() {
    const { segment_summary, clients, client_info } = this.props;
    //const clientName = client_info && client_info.name ? client_info.name : ""
    let client_name = client_info.name;
    let bu_name = "";
    if (client_info.parentClientId) {
      const parent_client = find(clients, c => {
        return c.id === client_info.parentClientId;
      });
      if (parent_client) {
        client_name = parent_client.name;
        bu_name = client_info.name;
      }
    }

    const fileName = segment_summary.name + "_chart_report.pdf";
    this.setState({
      showDataLoadingDialog: true,
      showDownloadDialog: false,
      loadingText: "Downloading, please wait...",
    });
    const box = document.getElementById("main-box");
    let viewportWidth = box.offsetWidth;
    box.style.width = 1024 + "px";
    //pdf.setFontSize(9);
    const pageWidth = 186;
    let summaryCanva = null;

    const els = document.getElementsByClassName("base-info");
    let isSummaryCanvaReady = false;
    if (els.length > 0) {
      const el = els[0];
      // const tvWidth = viewportWidth;
      // el.style.width = "1024px";
      setTimeout(function() {
        html2canvas(el, { logging: false }).then(function(canvas) {
          summaryCanva = canvas;
          isSummaryCanvaReady = true;
          // el.style.width = tvWidth + "px";
        });
      }, 200);
    }

    const demoEls = document.getElementsByClassName("demographic");
    const attrsCanvas = [];
    const isAttrsCanvasReady = [];
    map(
      filter(demoEls, el => {
        return !el.classList.contains("google-map");
      }),
      el => {
        if (!el.classList.contains("google-map")) {
          isAttrsCanvasReady.push(false);
          // const width = viewportWidth;
          // el.style.width = "1024px";
          setTimeout(function() {
            html2canvas(el, { logging: false }).then(function(canva) {
              attrsCanvas.push(canva);
              isAttrsCanvasReady.shift();
            });
          }, 200);
          // setTimeout(function() {
          // el.style.width = width + "px";
          // }, 100);
        }
      },
    );
    const _els = document.getElementsByClassName("google-map");

    let height = 30;
    if (els && els[0])
      height += (els[0].offsetHeight * PAGE_WIDTH) / els[0].offsetWidth + 4;
    if (_els && _els.length > 0) {
      const el = _els[0];
      height += (el.offsetHeight * PAGE_WIDTH) / el.offsetWidth + 4;
    }
    map(attrsCanvas, canva => {
      height += canva.offsetHeight / (canva.offsetWidth / pageWidth) + 4;
    });
    map(demoEls, canva => {
      height += canva.offsetHeight / (canva.offsetWidth / pageWidth) + 4;
    });
    height += 30;
    // if (viewportWidth < 1024) {
    //   box.style.width = viewportWidth + 'px';
    // }
    let pdf = new pdfConverter("p", "mm", "a4");
    if (height > 295) pdf = new pdfConverter("p", "mm", [210, height]);
    pdf.setFont("helvetica");
    pdf.setFontType("normal");

    let top = 10;
    let intervalId = setInterval(
      function() {
        if (isSummaryCanvaReady === false || !isEmpty(isAttrsCanvasReady)) {
          console.log("PDF generating...");
        } else {
          clearInterval(intervalId);
          pdf.setDrawColor(0, 123, 99);
          setTimeout(
            function() {
              this._addPdfHeader(pdf, client_name, bu_name);
              top = 30;
              pdf.addImage(
                summaryCanva.toDataURL(),
                "PNG",
                12,
                top,
                pageWidth,
                0,
              );
              const ratio =
                summaryCanva.height > 330
                  ? (1024 / pageWidth) * 2
                  : summaryCanva.height > 300
                  ? (1024 / pageWidth) * 1.2
                  : 1024 / pageWidth;
              top +=
                (summaryCanva.height * PAGE_WIDTH) / summaryCanva.width + 4;

              if (_els.length > 0) {
                const el = _els[0];
                // const w = viewportWidth;
                // el.style.width = "1024px";

                //FIX for gmap API > 3.33
                var gmStyle = document.getElementsByClassName("gm-style");
                const p = gmStyle[0].childNodes[0].childNodes[0];
                const t = p.childNodes[4].childNodes[0];
                const t1 = p.childNodes[0].childNodes[0].childNodes[0];
                const t2 = p.childNodes[1].childNodes[0].childNodes[0];
                [t, t1, t2].forEach(o => {
                  if (o) {
                    const transform = o.style.transform;
                    var comp = transform.split(","); //split up the transform matrix
                    var mapleft = parseFloat(comp[4]); //get left value
                    var maptop = parseFloat(comp[5]); //get top value
                    o.style.transform = "none";
                    o.style.left = mapleft + "px";
                    o.style.top = maptop + "px";
                  }
                });

                html2canvas(el, {
                  proxy: `${apiBaseUrl}/proxy/images`,
                  logging: false,
                  svgRendering: true,
                  useCORS: true,
                  allowTraint: false,
                }).then(
                  function(canvas) {
                    pdf.addImage(
                      canvas.toDataURL("image/png"),
                      "PNG",
                      12,
                      top,
                      pageWidth,
                      0,
                    );
                    // el.style.width = w + "px";
                    top += (canvas.height * PAGE_WIDTH) / canvas.width + 4;

                    this._addPdfElements(
                      attrsCanvas,
                      pdf,
                      top,
                      pageWidth,
                      fileName,
                      ratio,
                      client_name,
                      bu_name,
                      height,
                      () => {
                        box.style.width = viewportWidth + "px";
                      },
                    );
                  }.bind(this),
                );
              } else {
                this._addPdfElements(
                  attrsCanvas,
                  pdf,
                  top,
                  pageWidth,
                  fileName,
                  ratio,
                  client_name,
                  bu_name,
                  height,
                  () => {
                    box.style.width = viewportWidth + "px";
                  },
                );
              }
            }.bind(this),
            100,
          );
        }
      }.bind(this),
      1000,
    );
  }
  transformArray(array) {
    let arr = [];
    const { rules_count } = this.props;
    map(array, item => {
      let str = "";
      let sub_str = "";
      let name = "";
      if (item.id === 605606) {
        let count = 0;
        let ds = "";
        map(item.attributes, attr => {
          count += attr.values.length;
          const rule = find(rules_count, r => {
            return r.attributeId === attr.id;
          });
          ds = rule.dataSource;
          map(attr.values, v => {
            sub_str += `"${v.label}","${v.total}", ${ds}\r\n`;
          });
        });
        str = `AUTO MAKE/MODEL (${count}),Source Name,\r\n`;
        arr.push(str + sub_str + "\r\n");
      } else {
        name = item.name + ",,Source Name\r\n";
        let result = name;
        map(item.attributes, attr => {
          const rule = find(rules_count, r => {
            return r.attributeId === attr.id;
          });
          str = `${attr.name}(${attr.values && attr.values.length}),"${
            attr.total
          }",${rule.dataSource}\r\n`;
          map(attr.values, v => {
            sub_str += `"${v.label}","${v.total}",${rule.dataSource}\r\n`;
          });
          result += str;
          result += sub_str;
          str = "";
          sub_str = "";
        });
        arr.push(result + "\r\n");
      }
    });

    return arr.join("");
  }
  generateGeoString() {
    const { rules_count } = this.props;
    let arr = [];
    let ds = "";
    map(rules_count, r => {
      let str = "";
      let sub_str = "";
      if (
        r.attributeId === 1 ||
        r.attributeId === 2 ||
        r.attributeId === 3 ||
        r.attributeId === 4 ||
        r.attributeId === 7
      ) {
        let audienceCount = 0;
        map(r.counts, count => {
          sub_str += `"${count.key.replace(",", " ")}","${count.value}", ${
            r.dataSource
          }\r\n`;
          audienceCount += count.value;
        });
        str = `${r.attributeName} (${r.counts.length}),"${audienceCount}"\r\n`;
        arr.push(str + sub_str + "\r\n");
      }
      if (r.attributeId === 90 || r.attributeId === 91) {
        const { segment_summary } = this.props;
        const rawData = JSON.parse(segment_summary.rawData);
        const { addressLabel, radius, driveTime } = rawData.plotted_values;
        if (r.attributeId === 91) {
          str = " Custom Radius";
        } else {
          if (radius && addressLabel) {
            str = radius + " MILE(S) FROM " + addressLabel;
          }
          if (driveTime && addressLabel) {
            str = driveTime + " HOUR(S) DRIVE FROM " + addressLabel;
          }
          str = str
            .replace(",USA", "")
            .replace(", USA", "")
            .replace("USA", "");
        }
        str = `Location,"${str}"\nAudience Size,"${r.counts[0].value}",${r.dataSource}`;
        ds = r.dataSource;
        arr.push(str + "\r\n");
      }
    });
    if (isEmpty(arr)) {
      return "";
    }
    return "Geography,,Source Name,\r\n" + arr.join("");
  }
  _downloadAsCSV() {
    this.setState({
      showDataLoadingDialog: true,
      showDownloadDialog: false,
    });
    let newLine = window.navigator.msSaveOrOpenBlob ? "\r\n" : "\n";
    let csv_string = "";
    const { audience_total_count, segment_summary, parent_client } = this.props;
    let segmentName = `Audience Name,${this.formatNameTime(
      segment_summary.name,
    )}${newLine}`;
    let creteDate = `Creation Date,${moment(segment_summary.createdTime).format(
      "DD-MMM-YY",
    )}${newLine}`;
    let client = `Client,${
      segment_summary && isNil(parent_client)
        ? segment_summary.clientName
        : isNil(parent_client)
        ? ""
        : parent_client.name
    }${newLine}`;
    let businessUnit = `Business Unit,${
      parent_client ? segment_summary.clientName : ""
    }${newLine}`;
    let attributes = `Attributes Selected, ${segment_summary.rules.length}${newLine}`;
    let pdmLine = `Primary Decision Maker Selected, ${
      segment_summary.targetHouseholdsOnly ? "Yes" : "No"
    }${newLine}`;

    let audience = `Audience, ${audience_total_count.total}${newLine}`;
    let reachByChannel = `Reach By Channel,${newLine}`;
    let email = `Email, ${audience_total_count.email}${newLine}`;
    let social = `Social, ${audience_total_count.social}${newLine}`;
    let display = `Display, ${audience_total_count.display}${newLine}`;

    csv_string += segmentName;
    csv_string +=
      creteDate +
      client +
      businessUnit +
      attributes +
      pdmLine +
      audience +
      reachByChannel +
      email +
      social +
      display;
    //  'Geography,\n' + location + audience + ',\n'
    csv_string += "\r\n";
    csv_string += this.generateGeoString();
    csv_string += "\r\n";
    csv_string += this.transformArray(this.state.list);
    if (window.navigator.msSaveOrOpenBlob) {
      csv_string = "\ufeff" + csv_string;
      let blob = new Blob([csv_string], {
        type: "text/csv;charset=utf-8",
      });
      navigator.msSaveOrOpenBlob(
        blob,
        `${this.props.segment_summary.name}.csv`,
      );
    } else {
      csv_string =
        "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(csv_string);
      //let encodeUri = encodeURI(csv_string);
      let link = document.createElement("a");

      link.setAttribute("href", csv_string);
      link.setAttribute("download", `${this.props.segment_summary.name}.csv`);
      document.body.appendChild(link);
      link.click();
    }
    this.setState({
      showDataLoadingDialog: false,
    });
  }
  handleConfirmArchive() {
    // for the multiple segment archived.
    this.props.archiveSegment(this.props.segment_summary.id);
    // set timeout for async call back.
    window.setTimeout(() => {
      this.props.getSegmentList({
        ...this.props.recordActiveQueryParamsObj,
        clientId:
          parseInt(this.props.selected_client, 10) >= 0
            ? this.props.selected_client
            : null,
      });
      // when use `clear` as the only parameter, empty the arrary.
      this.props.selectedSegment("clear");
      this.props.history.push("/segments/list/archive");
    }, 800);
  }
  createAudienceFile() {
    this.setState({
      openCreateCampaignDialog: true,
    });
  }
  closeCreateCampaignDialog() {
    this.setState({
      openCreateCampaignDialog: false,
      ifShowEmailSubCheckbox: false,
      ifReturnEmailChecked: false,
      ifSocialMediaChecked: false,
      ifDisplayChecked: false,
      socialMediaFacebook: false, // when `the social media's selection facebook` checkbox is selected set value to `true`
      socialMediaGoogle: false,
    });
    // rollback ifRequestSuccess value
    this.props.rollbackRequestSuccessToFalse(false);
    this.setState({
      ifCreateAudienceFile: false,
    });
  }
  handleEmailChecked(e, isInputChecked) {
    if (!isInputChecked) {
      this.setState({
        ifShowEmailSubCheckbox: isInputChecked,
        ifReturnEmailChecked: isInputChecked,
      });
    }
    this.setState({
      ifShowEmailSubCheckbox: isInputChecked,
    });
  }
  handleReturnEmail(e, isInputChecked) {
    this.setState({
      ifReturnEmailChecked: isInputChecked,
    });
  }
  handleSocialMedia(e, isInputChecked) {
    this.setState({
      ifSocialMediaChecked: isInputChecked,
    });
    if (!isInputChecked) {
      this.setState({
        socialMediaFacebook: false,
        socialMediaGoogle: false,
      });
    } else {
      this.setState({
        socialMediaFacebook: true,
        socialMediaGoogle: true,
      });
    }
  }
  handleSocialMediaAllChecked() {
    this.setState({
      socialMediaFacebook: true,
      socialMediaGoogle: true,
    });
  }
  handleFacebookCheck(e, isInputChecked) {
    this.setState({
      socialMediaFacebook: isInputChecked,
    });
  }
  handleGoogleCheck(e, isInputChecked) {
    this.setState({
      socialMediaGoogle: isInputChecked,
    });
  }
  handleDisplayCheck(e, isInputChecked) {
    this.setState({
      ifDisplayChecked: isInputChecked,
    });
  }
  handleSelectAllCheckbox() {
    this.setState({
      ifShowEmailSubCheckbox: true,
      ifSocialMediaChecked: true,
      ifDisplayChecked: true,
    });
  }
  cbPDFChange(e, isInputChecked) {
    const result = !this.refs.cbCSV.state.switched && !isInputChecked;
    this.setState({ disabledDlBtn: result });
  }

  cbCSVChange(e, isInputChecked) {
    const result = !this.refs.cbPDF.state.switched && !isInputChecked;
    this.setState({ disabledDlBtn: result });
  }
  handleDownload(e) {
    e.preventDefault();

    if (this.refs.cbPDF.state.switched) {
      this._downloadAsPDF();
    }

    if (this.refs.cbCSV.state.switched) {
      this._downloadAsCSV();
    }
  }
  onRequestActivationClose() {
    this.setState({
      showActivateDialog: false,
    });
  }

  formatNameTime(name) {
    if (typeof name !== "string") return name;
    const originNames = name.match(/.*_(\d+)$/);
    if (!originNames || !originNames[1] || originNames[1].length !== 8)
      return name;
    const originName = originNames[1];
    const year = originName.substr(0, 4);
    const month = originName.substr(4, 2);
    const day = originName.substr(6);
    return name.replace(originName, `${month}${day}${year}`);
  }

  render() {
    const { audience_total_count, segment_summary } = this.props;
    const hasGmap =
      document.getElementsByClassName("geo-map-row-container").length > 0;
    return (
      <MuiThemeProvider>
        <div className="segment-detail" key="segment-detail-key">
          <div id="main-box">
            <div className="segment-btns clearfix mb-20 text-right">
              <div className="wrapper">
                <Button
                  title="Download Report"
                  handleClick={e => {
                    e.preventDefault();
                    this.setState({ showDownloadDialog: true });
                  }}
                />
                <Button
                  title="Activate Audience"
                  handleClick={e => {
                    e.preventDefault();
                    this.setState({ showActivateDialog: true });
                  }}
                  className="ml-20"
                />
                {parseInt(this.props.roleId, 10) === 1 && (
                  <Button
                    title="Create Audience File"
                    handleClick={e => {
                      e.preventDefault();
                      this.createAudienceFile();
                    }}
                    className="ml-20"
                  />
                )}
              </div>
            </div>
            <div className="base-info base">
              <h2>Audience</h2>
              <ul>
                <List itemName="Audience Name">
                  {this.props.segment_summary && this.props.segment_summary.name
                    ? this.formatNameTime(this.props.segment_summary.name)
                    : ""}
                </List>
                <List itemName="Creation Date">
                  {this.props.segment_summary &&
                    this.props.segment_summary.createdTime &&
                    moment(this.props.segment_summary.createdTime).format(
                      "MMMM DD, YYYY",
                    )}
                </List>
                <List itemName="Archive Date">
                  {segment_summary &&
                    segment_summary.archivedTime &&
                    moment(segment_summary.archivedTime).format(
                      "MMMM DD, YYYY",
                    )}
                </List>
                <List itemName="Client">
                  {this.props.segment_summary && isNil(this.props.parent_client)
                    ? this.props.segment_summary.clientName
                    : isNil(this.props.parent_client)
                    ? ""
                    : this.props.parent_client.name}
                </List>
                <List itemName="Business Unit">
                  {this.props.parent_client &&
                    this.props.segment_summary &&
                    this.props.segment_summary.clientName}
                </List>
                <List itemName="Attributes Selected">
                  {this.props.segment_summary &&
                    this.props.segment_summary.rules.length}
                </List>
                <List itemName="Reach By Channel">
                  {/*
                  <em>
                    <small>Direct Mail: </small>
                    {audience_total_count &&
                      splitNumber(audience_total_count.directMail)()}
                    </em>*/}
                  <em>
                    <small>Email: </small>
                    {audience_total_count &&
                      splitNumber(audience_total_count.email)()}
                  </em>
                  <em>
                    <small>Social/Display: </small>
                    {audience_total_count &&
                      splitNumber(audience_total_count.social)()}
                  </em>
                  <em>
                    <small>Direct Mail: </small>
                    {audience_total_count &&
                        splitNumber(audience_total_count.directMail)()}
                  </em>
                </List>
              </ul>
            </div>

            {this.generateGeoAttributesContent()}
            {this.state.list.map(item => {
              if (parseInt(item.id, 10) === 605606) {
                return this.generateAutoContent(item);
              } else
                return (
                  <div className="demographic base" key={item.id}>
                    <h3>{item.name}</h3>
                    <ul>
                      {item.attributes.map((list, index) => (
                        <li
                          className="active"
                          key={list.id}
                          style={{ marginTop: "-1px" }}
                        >
                          <section className="clearfix">
                            <span className="pull-left">
                              {list.name} (
                              {(list.values && list.values.length) ||
                                (list.subAttributes &&
                                  list.subAttributes.length)}
                              )
                            </span>
                          </section>
                          {list.values &&
                            list.values.map(v => {
                              let id = v.id.toString().substring(0, 3);
                              if (id === "140" || id === "150") {
                                id = v.id.toString().substring(0, 4);
                              }
                              return (
                                <div
                                  className="attr-item"
                                  key={v.id}
                                  style={{
                                    height: "53px",
                                    marginBottom: "1px",
                                  }}
                                >
                                  <p className="clearfix pl-10" ref="pElement">
                                    <span className="pull-left">{v.label}</span>
                                  </p>
                                </div>
                              );
                            })}
                          <div className="arrow-down" />
                        </li>
                      ))}
                    </ul>
                  </div>
                );
            })}

            <CreateCampaign
              openCreateCampaignDialog={this.state.openCreateCampaignDialog}
              closeCreateCampaignDialog={() => this.closeCreateCampaignDialog()}
              ifShowEmailSubCheckbox={this.state.ifShowEmailSubCheckbox}
              ifReturnEmailChecked={this.state.ifReturnEmailChecked}
              handleEmailChecked={(e, isInputChecked) =>
                this.handleEmailChecked(e, isInputChecked)
              }
              handleReturnEmail={(e, isInputChecked) =>
                this.handleReturnEmail(e, isInputChecked)
              }
              handleSocialMedia={(e, isInputChecked) =>
                this.handleSocialMedia(e, isInputChecked)
              }
              ifSocialMediaChecked={this.state.ifSocialMediaChecked}
              socialMediaFacebook={this.state.socialMediaFacebook}
              socialMediaGoogle={this.state.socialMediaGoogle}
              handleSocialMediaAllChecked={() =>
                this.handleSocialMediaAllChecked()
              }
              handleFacebookCheck={(e, isInputChecked) =>
                this.handleFacebookCheck(e, isInputChecked)
              }
              handleGoogleCheck={(e, isInputChecked) =>
                this.handleGoogleCheck(e, isInputChecked)
              }
              handleDisplayCheck={(e, isInputChecked) =>
                this.handleDisplayCheck(e, isInputChecked)
              }
              ifDisplayChecked={this.state.ifDisplayChecked}
              handleSelectAllCheckbox={() => this.handleSelectAllCheckbox()}
              createCampaign_segment_id={this.state.createCampaign_segment_id}
              getCreateCampaign={this.props.getCreateCampaign} // create campaign api function
              createCampaign_clientId={this.state.createCampaign_clientId}
              create_campaign={this.props.create_campaign}
              rollbackRequestSuccessToFalse={
                this.props.rollbackRequestSuccessToFalse
              }
            />
            <Dialog
              open={
                this.state.showDataLoadingDialog ||
                (hasGmap && !this.state.gmapIsReady)
              }
              style={{ top: "-1.8em" }}
              overlayStyle={{ opacity: 0.9, backgroundColor: "#666666" }}
              modal={true}
            >
              <Row className="mt-20">
                <Col xs="7" sm="7" md="7" lg="7" className="text-right">
                  <div>{this.state.loadingText}</div>
                </Col>
                <Col xs="1" sm="1" md="1" lg="1">
                  <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
                </Col>
              </Row>
            </Dialog>
            <Dialog
              open={this.state.showDownloadDialog}
              style={{ top: "-1.8em" }}
              modal={true}
              contentStyle={{ width: "440px" }}
            >
              <FullRow
                className="no-margin-top no-padding text-center"
                style={{ fontSize: "16px", color: "#000" }}
              >
                <strong>
                  Choose the type of file you would like to download
                </strong>
              </FullRow>
              <FullRow
                className="no-padding-top no-padding-right no-padding-bottom no-margin-bottom"
                style={{ paddingLeft: "150px" }}
              >
                <Checkbox
                  iconStyle={{ fill: "#47A1AB", marginRight: "10px" }}
                  label={"PDF File"}
                  labelStyle={{ fontSize: "14px" }}
                  defaultChecked={true}
                  ref="cbPDF"
                  onCheck={(e, isInputChecked) =>
                    this.cbPDFChange(e, isInputChecked)
                  }
                />
              </FullRow>
              <FullRow
                className="no-padding-top no-padding-right no-padding-bottom"
                style={{ paddingLeft: "150px" }}
              >
                <Checkbox
                  iconStyle={{ fill: "#47A1AB", marginRight: "10px" }}
                  label={"CSV File"}
                  labelStyle={{ fontSize: "13px" }}
                  defaultChecked={false}
                  ref="cbCSV"
                  onCheck={(e, isInputChecked) =>
                    this.cbCSVChange(e, isInputChecked)
                  }
                />
              </FullRow>
              <FullRow className="no-padding no-margin-bottom mt-20 text-center">
                <button
                  type="button"
                  onClick={() => this.setState({ showDownloadDialog: false })}
                  className="btn btn-default btn-aa-info mr-20"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={this.handleDownload.bind(this)}
                  disabled={this.state.disabledDlBtn}
                  className="btn btn-default btn-aa-default"
                >
                  Download File
                </button>
              </FullRow>
            </Dialog>
            <Dialog
              modal={false}
              open={this.state.openArchiveDialog}
              onRequestClose={() => {
                this.setState({ openArchiveDialog: false });
              }}
              contentStyle={{ width: "39%" }}
            >
              <p
                style={{
                  color: "black",
                  textAlign: "center",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                Click confirm to archive this audience
              </p>
              <div
                className="btns"
                style={{ textAlign: "center", marginTop: "1em" }}
              >
                <FlatButton
                  label="CANCEL"
                  backgroundColor="#FFF"
                  labelStyle={{ color: "black" }}
                  onClick={() => this.setState({ openArchiveDialog: false })}
                  hoverColor="#FFF"
                  className="btn-aa-info mr-20"
                />
                <FlatButton
                  label="ARCHIVE SEGMENT"
                  backgroundColor="#DD0000"
                  labelStyle={{
                    color: "#FFF",
                    padding: 0,
                    verticalAlign: "inherit",
                  }}
                  onClick={() => this.handleConfirmArchive()}
                  hoverColor="#DD0000"
                  className="btn-aa-warning btn-aa-default btn-aa"
                />
              </div>
            </Dialog>
            <FullRow className="text-right no-padding-top no-padding-right">
              <Button
                title="Archive"
                handleClick={e => {
                  e.preventDefault();
                  this.setState({ openArchiveDialog: true });
                }}
              />
              <Button
                title="Edit"
                className="ml-20"
                handleClick={e => {
                  e.preventDefault();
                  this.props.getSegmentWithRules(this.props.segment_summary.id);
                  this.props.selectClient(this.props.segment_summary.clientId);
                }}
                disabled={this.props.roleId === 5}
              />
            </FullRow>
            <ActivateAudienceDialog
              open={this.state.showActivateDialog}
              segment_summary={this.props.segment_summary}
              request_error={this.props.request_activation_error}
              request_success={this.props.request_activation_success}
              key={
                this.props.segment_summary
                  ? this.props.segment_summary.id
                  : undefined
              }
              submitActivateRequest={this.props.requestActivation}
              onRequestActivationClose={this.onRequestActivationClose.bind(
                this,
              )}
            />
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default SegmentDetail;



// WEBPACK FOOTER //
// ./src/components/NewSegmentDetail/Index.jsx